module.exports = __webpack_public_path__ + "media/src/images/logo-3662dda29689821aadc65477ae08d0d6.png";